<template>
  <div data-v-d27b4d60="" data-v-e5781868="" class="myAccount mainContent top50">
    <div data-v-d27b4d60="" class="content">
      <div data-v-d27b4d60="" class="top zeroLevel">
        <div data-v-d27b4d60="" class="box" style="width: 100%; background-image: url('https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/static/img/normal-1.2721da08.png')">
          <div data-v-d27b4d60="" class="box-inner">
            <div data-v-d27b4d60="" class="username">
              <div data-v-d27b4d60="" class="text">
                尊敬的 <span data-v-d27b4d60="" style="margin-left: 5px">{{ $store.state.userInfo.username }}</span>
              </div>
            </div>
            <div data-v-d27b4d60="" class="bottom-section">
              <div data-v-d27b4d60="" class="group">
                <div data-v-d27b4d60="" class="inputGroup">
                  <label data-v-d27b4d60="">CNY账户</label>
                  <input data-v-d27b4d60="" type="text" :value="$store.state.userInfo.balance" />
                  <span data-v-d27b4d60="" class="current"
                    ><svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon greenDot">
                      <use data-v-338e1447="" xlink:href="#icon-greenDot"></use>
                    </svg>
                    使用中
                  </span>
                </div>
                <div data-v-d27b4d60="" class="help">
                  <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon iconHelp">
                    <use data-v-338e1447="" xlink:href="#icon-iconHelp"></use>
                  </svg>
                  <div data-v-d27b4d60="" class="message">请选择一种资产进行游戏</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-d27b4d60="" class="nav">
        <ul data-v-d27b4d60="">
          <a href="javascript:void(0);" @click="$parent.goNav('/accountSetting')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconSetting">
                <use data-v-338e1447="" xlink:href="#icon-iconSetting"></use>
              </svg>
              账户设置
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/myWallet')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconWallet">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              我的钱包
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/transfer')">
            <li data-v-d27b4d60="" class="active">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconWallet">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              转账
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/fundingRecords')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconRecord">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              资金记录
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/activityRecord')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconRecord">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              活动及代理
            </li>
          </a>
        </ul>
      </div>

      <div data-v-1eba2a24="" data-v-d27b4d60="" class="myWallet washCode">
        <div data-v-1eba2a24="" class="topTxt">
          <div data-v-1eba2a24="" class="item">
            <h1 data-v-1eba2a24="">转账</h1>
            <div data-v-1eba2a24="" class="divider"></div>
            <p data-v-1eba2a24="">场馆钱包之间不可以互转。当您开启免转钱包时，每个场馆无需转账即可畅玩。</p>
          </div>
        </div>
        <div data-v-c74e5e22="" class="_3AwqQ9Nt">
          <div data-v-c74e5e22="" class="_3uhGlsJA">主账户</div>
          <div data-v-c74e5e22="" class="_222AIEz7">¥{{ $store.state.userInfo.balance }}元</div>
          <div data-v-c74e5e22="" class="wEDAX4ja">
            <img
              style="width: 18px; margin-right: 5px"
              data-v-c74e5e22=""
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAcCAMAAABBJv+bAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABvUExURUxpcdqagdiWgNeWgP/dltiXgOCnh9eWgNiXgNiWf9ybh9eXf9iWgNeWgNeWgNiXgNeWf9eWf9iWgNiXgNmZgdmZgdeWgNeWgNiXf9eWgNqbf9iWf9eXf9eWf9eWf9iWgd+ff9iYf9eXf9iWf9eWf00yFsAAAAAkdFJOUwAqxvwCTwj3QfMOZ+CquWyxwH6PLzbc54XRG5qhetZHGFxgePmWBHcAAADtSURBVHjafZPbroMgEEVHRblYb1XRVq09Pfv/v7GxCYHo6HohZIUJsxnIIVQb3+TwqvMnHRD5AEdSRDvbvQBZ5GvXp+MDSO4itKmGXjK3Uw1QZoFNEL8poJKBjzQKt3EFJCZ3qwdiZ31BYKUff9BMKxOs+B22uNMRo5Fuaw9piKFFuS0jakZGi4I05UQNckbPaDRiWLJQjO4lNlLSCBMOowJmOtNUAYMhV/zIctuEuxqLb4zHx8LjQ+Xhn6QqzcWDfoDuYhwStKfDJP4T1OJkFMXaAHW2H2S9DbL6jBaQ1cU3kHPkxe4TxUUVpvQFhcEU/UFvXFcAAAAASUVORK5CYII="
              alt=""
            />
            刷新
          </div>
          <div data-v-c74e5e22="" class="g0QdLp5Y">一键回收</div>
          <div data-v-c74e5e22="" class="_3uhGlsJA" style="margin-left: 20px">游戏余额</div>
          <div data-v-c74e5e22="" class="_222AIEz7">¥{{ $store.state.userInfo.gameblance }}元</div>
          <div data-v-c74e5e22="" class="_1thJMFup"><em data-v-c74e5e22="" @click="$parent.goNav('/fundingRecords?type=2')" class="_1-tG2KDV">前往领取福利 &gt;</em></div>
          <div style="flex:1"></div>
          <el-radio-group style="margin-left:50px" fill="#ffcb4c" size="mini" v-model="$store.state.userInfo.transferstatus" @change="changeTasfer">
            <el-radio-button :label="0">转账模式</el-radio-button>
            <el-radio-button :label="1">免转模式</el-radio-button>
          </el-radio-group>
        </div>
        <div class="box">
          <div data-v-69650277="" class="flexGroup">
            <div data-v-69650277="" class="col col1" v-for="(item, index) in balancelist" :key="index">
              <p data-v-69650277="">{{ item.name }}</p>
              <h1 data-v-69650277="">{{ item.balance }}</h1>
              <a data-v-69650277="" v-if="$store.state.userInfo.transferstatus == 0" @click="oneUpdate(item)" class="btn buttonSolid">额度转换</a>
            </div>
          </div>
        </div>

        <!--额度转换-->
        <div data-v-226bc1a2="" data-v-1eba2a24="" v-if="show" class="mask addBankCardDialog backdrop">
          <div data-v-226bc1a2="" class="popup pop1">
            <span data-v-226bc1a2="" class="close" @click="hideShow"></span>
            <div data-v-226bc1a2="" class="titlebar">额度转换</div>
            <div data-v-226bc1a2="" class="form">
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box dropbank" @click="openBank">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconCard1">
                      <use data-v-338e1447="" xlink:href="#icon-iconCard1"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" :value="payType == 0 ? '转入' : '转出'" disabled placeholder="转账方式" class="form-input form-input2" id="bank" />
                  <div data-v-226bc1a2="" class="icon">
                    <img
                      data-v-226bc1a2=""
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMWZmNzA2NS04OWJmLTRjYjItODdmZS03ZTQ4YmFlOTBkNDAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTRBRTM0RTNGMUFDMTFFNkFGQzhGNjUxQ0Y5Qjc5RTEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTRBRTM0RTJGMUFDMTFFNkFGQzhGNjUxQ0Y5Qjc5RTEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpiOWJiYTMwNi02NzY2LTRjZTgtOTAwOS03Zjc2OTM0NTEyNTQiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo4NWViOTEwZi0yM2RiLTExN2EtOGQ5My1jZTY0N2FjZDJlZDkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5GQ7trAAAAaklEQVR42mJsamqaw8DAkMxAGMxlAhLZQHyGgEKQfDZI8U8gDgbi1zgUvobK/2SCCjwC4kgg/oumEMSPhsozMCFJ7AXiKjTFIP5uGIcJTbIbiNdC2WuhfDhgQVP8H4iTgJgZSv9HlgQIMAAvsRYhT0B6LgAAAABJRU5ErkJggg=="
                      alt=""
                      class="icon-arrow"
                    />
                  </div>
                  <div data-v-226bc1a2="" class="dropDown" v-if="bankShow">
                    <div data-v-226bc1a2="" class="dropDownList">
                      <!-- <h1 data-v-226bc1a2="">{{$store.state.appInfo.title}}推荐的银行-支持2小时内到账 <span data-v-226bc1a2="">推荐</span></h1> -->
                      <ul data-v-226bc1a2="" class="bankList">
                        <li data-v-226bc1a2="" @click="changVal('payType', 0)">
                          <span>转入</span>
                        </li>
                        <li data-v-226bc1a2="" @click="changVal('payType', 1)">
                          <span>转出</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div data-v-226bc1a2="" class="errorTxt"></div>
              </div>
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon user">
                      <use data-v-338e1447="" xlink:href="#icon-user"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" class="form-input form-input2" placeholder="平台账户余额" :value="$store.state.userInfo.balance" disabled />
                </div>
                <div data-v-226bc1a2="" class="errorTxt"></div>
              </div>
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconCard2">
                      <use data-v-338e1447="" xlink:href="#icon-iconCard2"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" placeholder="游戏账户余额" :value="oneInfo.balance" disabled class="form-input form-input2" />
                </div>
                <div data-v-226bc1a2="" class="errorTxt"></div>
              </div>
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconPin">
                      <use data-v-338e1447="" xlink:href="#icon-iconPin"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" placeholder="操作金额" v-model="amount" class="form-input form-input2" />
                </div>
                <div data-v-226bc1a2="" class="errorTxt" style="display: none"></div>
              </div>
            </div>
            <div data-v-226bc1a2="" class="button"><span data-v-226bc1a2="" @click="isOk" class="btn">确定</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'transfer',
  data() {
    return {
      addShow: false,
      bankShow: false,
      banklist: [],
      delBox: {},
      baseURL: '',
      bank: null,
      bank_owner: null,
      pay_pass: null,
      bank_no: null,
      bank_address: null,
      cardLis: [],
      daoTime: null,
      balancelist: [],
      oneInfo: {},
      show: false,
      payType: 0,
      amount: null,
    };
  },
  created() {
    let that = this;
    that.getbalancelists();
    that.daoTime = setInterval(() => {
      that.getbalancelist();
    }, 2500);
  },
  methods: {
    isOk() {
      let that = this;
      let info = { amount: that.amount };
      if (that.amount == null) {
        that.$parent.showTost(0, '请输入操作金额！');
        return;
      }
      if (that.payType == 0) {
        //转入
        info.sourcetype = 'userbalance'; //sourcetype  出钱的
        info.targettype = that.oneInfo.platname; //targettype  收钱的
        if (that.amount * 1 > that.$store.state.userInfo.balance * 1) {
          //
          that.$parent.showTost(0, '操作金额超出了您的账户余额！');
          return;
        }
      }
      if (that.payType == 1) {
        //转出
        info.sourcetype = that.oneInfo.platname;
        info.targettype = 'userbalance';
        if (that.amount * 1 > that.oneInfo.balance * 1) {
          //
          that.$parent.showTost(0, '操作金额超出了您该游戏平台的余额！');
          return;
        }
      }
      that.$parent.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.$parent.showTost(1, res.message);

        if (res.code === 200) {
          that.hideShow();
          that.refreshusermoney();
          that.getbalancelists();
        } else {
          that.$parent.hideLoading();
        }
      });
    },
    changeTasfer(e) {
      let that = this;
      that.$parent.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = e;

      that.$apiFun
        .post('/api/uptransferstatus', { transferstatus: mianzhuan })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
            that.$parent.showTost(1, '操作成功！');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changVal(name, val) {
      let that = this;
      that[name] = val;
    },
    hideShow() {
      this.show = false;
      this.amount = null;
    },
    oneUpdate(val) {
      let that = this;
      that.oneInfo = val;
      that.show = true;
    },
    getbalancelists() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {

          if (res.code === 200) {
            that.balancelist = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelist() {
      let that = this;
      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
          }
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    delShow(item) {
      let that = this;
      that.delBox = item;
    },
    closeDel() {
      let that = this;
      that.delBox = {};
    },
    isDelOk() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/delcard', { id: that.delBox.id }).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.$parent.showTost(1, '解绑成功');
          that.delBox = {};

          that.getcard();
        }
        that.$parent.hideLoading();
      });
    },
    bindCard() {
      let that = this;
      if (!that.bank_owner) {
        that.$parent.showTost(0, '请输入姓名');
        return;
      }
      if (!that.bank) {
        that.$parent.showTost(0, '请输入银行');
        return;
      }
      if (!that.bank_address) {
        that.$parent.showTost(0, '请输入开户行地址');
        return;
      }
      if (!that.bank_no) {
        that.$parent.showTost(0, '请输入银行卡号');
        return;
      }
      if (!that.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      if (that.bank_no.length < 8) {
        that.$parent.showTost(0, '请输入正确的卡号长度');
        return;
      }
      if (that.pay_pass.length < 6 || that.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输入支付密码长度');
        return;
      }
      that.$parent.showLoading();
      let info = { bank_owner: that.bank_owner, bank: that.bank, bank_address: that.bank_address, bank_no: that.bank_no, pay_pass: that.pay_pass };
      that.$apiFun
        .post('/api/bindcard', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
            that.getcard();
            that.changAddShow();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getBanklist() {
      let that = this;
      that.$apiFun.post('/api/banklist', {}).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.banklist = res.data;
        }
      });
    },
    openBank() {
      this.bankShow = !this.bankShow;
    },
    getcard() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getcard', { type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changAddShow() {
      let that = this;
      that.bank_owner = null;
      that.bank = null;
      that.bank_address = null;
      that.bank_no = null;
      that.pay_pass = null;
      if (this.addShow == false && that.cardLis.length >= 5) {
        that.$parent.showTost(0, '最多添加5张银行卡');
        return;
      }
      this.addShow = !this.addShow;
    },
    //弹出登录框
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    //弹出注册框
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    //弹出忘记密码框
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
    changBank(bank) {
      let that = this;
      that.bank = bank;
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    transall() {
      let that = this;
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(1, res.message);
          that.refreshusermoney();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;

    //刷新
    $('.wEDAX4ja').click(function () {
      that.$parent.showLoading();
      that.refreshusermoney();
      that.getbalancelist();
    });
    //一键回收
    $('.g0QdLp5Y').click(function () {
      that.$parent.showLoading();
      that.transall();
    });
    //首页banner
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    //首页时间轴品牌历程
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    //盈利榜
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });

    // 弹出银行下拉
    // $('.dropbank').click(function () {
    //   $(this).find('.dropDown').toggle();
    // });
    // 选择银行
    // $('.bankList li').click(function () {
    //   var bankName = $(this).find('span').text();
    //   $('#bank').val(bankName);
    // });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-06254e6a.f0cc50a1.css';
@import '../../../static/css/chunk-645a6edf.25ca78d5.css';
@import '../../../static/css/chunk-4344ad92.cf88b5c7.css';
@import '../../../static/css/chunk-970915c0.1e5ddf77.css';

.myWallet .bankcardList .box.bg2[data-v-3917b340] {
  background: url(/static/image/bg2.c14d2591.png) no-repeat;
  background-size: 100% 100%;
  border: 1px solid #1f2026;
}
.myWallet .bankcardList .box .mask[data-v-3917b340],
.myWallet .bankcardList .box[data-v-3917b340] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.myWallet .bankcardList .box[data-v-3917b340] {
  background: #191a1f;
  border: 1px dashed #5b5f67;
  border-radius: 0.08rem;
  border-radius: 8px;
  width: 4.09rem;
  height: 1.5rem;
  margin-bottom: 0.2rem;
  margin-right: 4px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.myWallet .bankcardList .box .delete[data-v-3917b340] {
  display: none;
  position: absolute;
  width: 0.34rem;
  height: 0.34rem;
  top: 0.01rem;
  right: 0.01rem;
  cursor: pointer;
}

.svg-icon[data-v-338e1447] {
  width: 10em;
  height: 10em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.myWallet .bankcardList .box .txt .cardName[data-v-3917b340],
.myWallet .bankcardList .box .txt[data-v-3917b340] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.myWallet .bankcardList .box .txt[data-v-3917b340] {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  width: 100%;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  margin-bottom: 0.3rem;
}
.myWallet .bankcardList .box .txt .cardName[data-v-3917b340] {
  font-size: 0.2rem;
  color: #fff;
  letter-spacing: 0;
  text-align: left;
}

.myWallet .bankcardList .box .txt .cardName[data-v-3917b340],
.myWallet .bankcardList .box .txt[data-v-3917b340] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.myWallet .bankcardList .bankIcon[data-v-3917b340] {
  display: inline-block;
  margin-right: 0.15rem;
  width: 0.24rem;
  height: 0.24rem;
}

.svg-icon[data-v-338e1447] {
  width: 10em;
  height: 10em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.myWallet .bankcardList .box .txt[data-v-3917b340]:last-child {
  margin-bottom: 0;
}

.myWallet .bankcardList .box .txt .cardName[data-v-3917b340],
.myWallet .bankcardList .box .txt[data-v-3917b340] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.myWallet .bankcardList .box .txt[data-v-3917b340] {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  margin-bottom: 0.3rem;
}
.myWallet .bankcardList .box .txt .cardNum[data-v-3917b340] {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.3rem;
  color: #fff;
  letter-spacing: 0;
}
.myWallet .bankcardList .box .txt .type[data-v-3917b340] {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  padding: 0 0.04rem;
  height: 0.22rem;
  background-image: linear-gradient(135deg, #424242, #000);
  border-radius: 0.02rem;
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #f9cb5c;
  letter-spacing: 0;
  text-align: right;
  line-height: 0.18rem;
  font-weight: 400;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.washCode .box .flexGroup[data-v-69650277] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  // justify-content: space-;
  margin-bottom: 0.2rem;
  flex-wrap: wrap;
}
.washCode .box .flexGroup .col.col1[data-v-69650277] {
  width: 2.8rem;
  margin-bottom: 0.2rem;
  margin-right: 0.2rem;
}

.washCode .box .flexGroup .col[data-v-69650277] {
  width: 3.74rem;
  height: 1.25rem;
  background: #191a1f;
  border-radius: 0.08rem;
  padding: 0.26rem 0.2rem;
  position: relative;
}
.washCode .box .flexGroup .col p[data-v-69650277] {
  font-size: 0.16rem;
  color: #8e8e99;
  margin-bottom: 0.15rem;
}
.washCode .box .flexGroup .col h1[data-v-69650277] {
  font-family: DINAlternate-Bold;
  font-size: 0.34rem;
  color: #fff;
  line-height: 0.34rem;
}
.washCode .box .flexGroup .col .btn.disabled[data-v-69650277] {
  background: #777780;
  color: #1f2026;
}
.washCode .box .flexGroup .col .btn[data-v-69650277] {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  position: absolute;
  bottom: 0.3rem;
  right: 0.3rem;
  font-weight: 700;
}
.buttonSolid[data-v-69650277] {
  background: #ffcb4c;
  border-radius: 0.04rem;
  text-align: center;
  font-size: 0.16rem;
  color: #4d2e0f;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
._3AwqQ9Nt {
  height: 60px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-family: PingFangSC-Regular, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
}
._3AwqQ9Nt ._3uhGlsJA {
  font-size: 14px;
}
._3AwqQ9Nt ._222AIEz7 {
  float: left;
  margin: 0 10px;
  display: block;
  min-width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: DINAlternate-Bold, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 16px;
  color: #d7967f;
  line-height: 20px;
}
._3AwqQ9Nt .wEDAX4ja {
  border: 1px solid transparent;
  background: transparent;
  background-size: 100% 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 12px;
  color: #d7967f;
  line-height: 18px;
  margin-right: 15px;
  cursor: pointer;
}
._3AwqQ9Nt .g0QdLp5Y {
  font-size: 12px;
  color: #d7967f;
  line-height: 18px;
  -webkit-transition: all 0.6s;
  transition: all 0.6s;
  background: transparent;
  cursor: pointer;
}
._3AwqQ9Nt ._1thJMFup {
  margin-left: 54px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._3AwqQ9Nt ._1thJMFup {
  margin-left: 54px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._3AwqQ9Nt ._1thJMFup ._1-tG2KDV {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 18px;
  color: #d7967f !important;
  margin-left: 16px !important;
  cursor: pointer;
}

._3AwqQ9Nt ._1thJMFup em {
  font-size: 14px;
  color: #98a3b1;
  font-weight: 400;
  margin-left: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/mode/transfer.vue